export const GET_COURIERS_LOCATIONS = Symbol('GET_COURIERS_LOCATIONS');
export const GET_COURIERS_LOCATIONS_REQUEST = Symbol('GET_COURIERS_LOCATIONS_REQUEST');
export const GET_COURIERS_LOCATIONS_SUCCESS = Symbol('GET_COURIERS_LOCATIONS_SUCCESS');
export const GET_COURIERS_LOCATIONS_ERROR = Symbol('GET_COURIERS_LOCATIONS_ERROR');

